import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'antd';
import { FileAddOutlined } from '@ant-design/icons';
import { MSG_TOOLTIP_ADICIONAR_ARQUIVO } from 'utils/consts';
import { checkUploadImagem } from '../Button';
import * as S from '../styles';

export const ComponentButtonUpload = ({
  buttonType,
  disabled = false,
  outline,
  iconDirection = 'left',
  color = 'blue',
  type = 'primary',
  funcUpload,
  ...rest
}) => {
  const handleUploadImagem = e => {
    checkUploadImagem(e, funcUpload);
  };

  const clickAction = () => {
    document.getElementById('flBtnTypeFile').click();
  };

  return (
    <S.ButtonContain
      color={color}
      outline={outline}
      iconDirection={iconDirection}
      buttonType={buttonType}
      id="ComponenteButtonContain"
    >
      <Tooltip title={MSG_TOOLTIP_ADICIONAR_ARQUIVO} color={'#108ee9'} key={MSG_TOOLTIP_ADICIONAR_ARQUIVO}>
        <Button
          data-testid="btn upload"
          type={type}
          size={'large'}
          icon={<FileAddOutlined aria-label="Botão de adicionar arquivos" />}
          onClick={clickAction}
          disabled={disabled}
          {...rest}
        />
      </Tooltip>
      <input id="flBtnTypeFile" type="file" hidden onChange={handleUploadImagem} accept=".pdf" />
    </S.ButtonContain>
  );
};

ComponentButtonUpload.propTypes = {
  buttonType: PropTypes.string,
  disabled: PropTypes.bool,
  outline: PropTypes.bool,
  iconDirection: PropTypes.string,
  color: PropTypes.string,
  type: PropTypes.string,
  funcUpload: PropTypes.func,
};

ComponentButtonUpload.defaultProps = {
  // buttonType: null,
  // disabled: false,
  // outline: null,
  // iconDirection: 'left',
  // color: 'blue',
  // type: 'primary',
  // funcUpload: functionMock,
};

export default ComponentButtonUpload;
